import React, { useEffect, useState } from 'react'
import { KeyboardAvoidingView, StyleSheet, Text, TextInput, TouchableOpacity, View, Image } from 'react-native'
import { Input, Button, Heading } from 'native-base'
import { useNavigation } from '@react-navigation/core'
import { auth, db } from '../firebase'
import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth'
import { setDoc, doc } from 'firebase/firestore'
import { useRecoilValue } from 'recoil'
import { userState } from '../state/atoms'
import { FontAwesome } from '@expo/vector-icons'
import { Video } from 'expo-av'

const IntroScreen = () => {
    // Local State
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [showPass, setShowPass] = useState(false)

    // Global State
    const userDataTemplate = useRecoilValue(userState)

    const navigation = useNavigation()

    // Removes listener once signed in
    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            if (user) {
                navigation.replace('MainContainer')
            }
        })
        return unsubscribe
    }, [])

    // Registration function
    const handleSignup = () => {
        createUserWithEmailAndPassword(auth, email, password)
            .then(async (userCredential) => {
                const userID = userCredential.user.uid
                await setDoc(doc(db, 'users', userID), userDataTemplate)
            })
            .catch((error) => {
                const errorCode = error.code
                const errorMessage = error.message
                alert(errorMessage)
            })
    }

    // Login Auth check
    const handleLogin = () => {
        signInWithEmailAndPassword(auth, email, password)
            .then((userCredentials) => {
                const user = userCredentials.user
                console.log('Logged in with: ', user.email)
            })
            .catch((error) => alert(error.message))
    }

    return (
        <>
            <View style={styles.container} behavior="padding">
                <Video source={require('../assets/videos/intro.mp4')} resizeMode="cover" isLooping isMuted shouldPlay style={{ position: 'absolute', width: '100%', height: '100%', opacity: 0.3 }} />
                <Image style={styles.homeLogo} source={require('../assets/logos/ZHOnly.png')} />
                <Heading style={{ color: '#393939', textAlign: 'center', fontSize: 18, lineHeight: 22, paddingLeft: 50, paddingRight: 50 }}>Find abandonded homes in your neighborhood. Send us the info along with pictures and get rewarded. </Heading>
                <View style={styles.buttonContainer}>
                    <TouchableOpacity onPress={() => navigation.navigate('Login')} style={styles.button}>
                        <Text style={styles.buttonText}>Login to your account</Text>
                    </TouchableOpacity>
                    <TouchableOpacity onPress={() => navigation.navigate('Onboarding')} style={[styles.button, styles.buttonOutline]}>
                        <Text style={styles.buttonOutlineText}>Signup for a new account</Text>
                    </TouchableOpacity>
                </View>
            </View>
        </>
    )
}

export default IntroScreen

const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    inputContainer: {
        width: '80%',
        height: 120,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    emailField: {
        backgroundColor: '#fff',
        borderRadius: 5,
        height: 50,
        fontSize: 16,
    },
    passwordField: {
        backgroundColor: '#fff',
        borderRadius: 5,
        height: 50,
        fontSize: 16,
    },
    secondaryActions: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: 10,
        width: '100%',
    },
    secondaryActionText: {
        color: 'gray',
        fontSize: 16,
    },
    buttonContainer: {
        width: '80%',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 40,
    },
    button: {
        backgroundColor: '#6c387a',
        width: '100%',
        padding: 15,
        borderRadius: 5,
        alignItems: 'center',
    },
    buttonOutline: {
        backgroundColor: 'rgba(256, 256, 256, 0.7)',
        marginTop: 15,
        borderColor: '#6c387a',
        borderWidth: 2,
    },
    buttonText: {
        color: 'white',
        fontWeight: '700',
        fontSize: 16,
    },
    buttonOutlineText: {
        color: '#6c387a',
        fontWeight: '700',
        fontSize: 16,
    },
    homeLogo: {
        width: '45%',
        height: undefined,
        aspectRatio: 205 / 152,
        marginBottom: 20,
    },
})
